<!--
 * @Descripttion: 
 * @version: 
 * @Author: lzs
 * @Date: 2022-05-31 11:32:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-06-01 15:52:55
-->
<template>
  <div ref="chartDom" class="chart-content"></div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      myChart: null,
    };
  },
  created() {
    this.$on("setChart", (option, isLine) => {
      this.$nextTick(() => {
        const chartDom = this.$refs["chartDom"];
        this.myChart = echarts.init(chartDom);
        let stableOption = {
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#fff",
            },
          },
          legend: {
            textStyle: {
              color: "#ffffff",
            },
          },
          grid: {
            left: "0",
            right: "2%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            axisLine: {
              show: false, //x轴数轴
            },
            splitLine: {
              show: false, //x轴分割线
            },
            axisTick: {
              show: false, //x轴分隔符
            },
            axisLabel: {
              color: "#fff", //坐标字体颜色
            },
          },
          yAxis: {
            name: "单位(kWh)",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#314179"],
              },
            },
            axisLabel: {
              color: "#fff",
            },
          },
        };
        if (isLine) {
          stableOption.xAxis = Object.assign(stableOption.xAxis, option.xAxis);
          option = Object.assign(option, stableOption);
        }
        this.myChart.setOption(option);
        // 不加resize是因为在父组件触发重新渲染
      });
    });
  },
  methods: {
    resizeChart() {
      this.myChart.dispose(); //移除echart
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-content {
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
</style>
